@if (url$ | async; as url) {
  <a [href]="url">Skip to content </a>
}
